import { useState } from 'react'
import styled from 'styled-components'
import { DutyOrderField, OrderDirection } from 'generated/graphql'
import { PAGE_SIZE } from '@app.feature/activityList/constants/constant'
import { useDutyModalStore } from '../../../store/dutyModal'
import SelectBox from './filterSelect/SelectBox'
import SelectOption, { TOptionsValue } from './filterSelect/SelectOption'

const ACTIVITY_OPTIONS = [
  { label: '인기순', value: DutyOrderField.SELF_INTRODUCTION_COUNT },
  { label: '공고 마감일 순', value: DutyOrderField.END_AT },
  { label: '최신순', value: DutyOrderField.JOB_TYPE_CREATED_AT },
]

const ActivityFilter = () => {
  const [selectedOption, setSelectedOption] = useState<TOptionsValue>(
    ACTIVITY_OPTIONS[0],
  )
  const [isShowOptions, setIsShowOptions] = useState<boolean>(false)

  const variables = useDutyModalStore((store) => store.variables)
  const setVariables = useDutyModalStore((store) => store.setVariables)

  const handleToggleOptions = () => {
    setIsShowOptions((prev) => !prev)
  }

  const handleChangeSelectedValue = (option: TOptionsValue) => {
    setIsShowOptions(false)
    const direction =
      option.value === DutyOrderField.END_AT
        ? OrderDirection.ASC
        : OrderDirection.DESC
    setVariables({
      ...variables,
      filterBy: {
        ...variables?.filterBy,
      },
      orderBy: {
        field: option.value,
        direction: direction,
      },
      pagination: {
        page: 1,
        pageSize: PAGE_SIZE,
      },
    })
    setSelectedOption(option)
  }

  return (
    <StyledWrapper>
      <SelectBox
        selectValue={selectedOption.label}
        onClick={handleToggleOptions}
        isFocused={isShowOptions}
      />
      {isShowOptions && (
        <SelectOption
          options={ACTIVITY_OPTIONS}
          onClick={handleChangeSelectedValue}
        />
      )}
    </StyledWrapper>
  )
}

export default ActivityFilter

const StyledWrapper = styled.div`
  position: relative;
  cursor: pointer;
  width: 140px;

  > div > p {
    font-size: 14px;
    margin: 0px !important;
  }
  > ul {
    margin: 0px !important;
    height: max-content;
  }
`
